module.exports = __webpack_public_path__ + "img/MargaritoPenaloza.7a138691.jpg";